module.exports = __webpack_public_path__ + "img/about/80243-031.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-031.png
// module id = 31
// module chunks = 0